import NavigationGroup from '@/classes/navigationGroup';

import Vue from 'vue';

const state = {
  navigationGroups: {},
};

const getters = {
  menuNavigationGroup: (state, getters, rootState, rootGetters) => {
    if (rootGetters['app/isMasteryApp']) {
      let userClass = rootGetters['session/userClass'];
      let navigationName = 'web-main';
      if (userClass) {
        navigationName = navigationName + '-' + userClass;
      }
      const ng = getters.navigationGroupsList.find(ng => ng.name === navigationName);
      if (ng) {
        return ng;
      }
    }
    return getters.navigationGroupsList.find(ng => ng.name === 'web-main');
  },
  navigationGroups: state => state.navigationGroups,
  navigationGroupsList: state => Object.keys(state.navigationGroups).map(id => state.navigationGroups[id]),
};

const mutations = {
  setNavigationGroups: function(state, groups) {
    groups.forEach(group => {
      const navigationGroup = new NavigationGroup(group);
      Vue.set(state.navigationGroups, navigationGroup.id, navigationGroup);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
